import { render } from "./DataChart.vue?vue&type=template&id=391a9408&scoped=true"
import script from "./DataChart.vue?vue&type=script&lang=js"
export * from "./DataChart.vue?vue&type=script&lang=js"

import "./DataChart.vue?vue&type=style&index=0&id=391a9408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391a9408"]])

export default __exports__